import {Subject} from 'rxjs'
import {Message} from 'components/message'
import {PbmFuncionalService} from './pbm-funcional.service'
import {ModalPbmObserver} from '../modal-pbm.observer'
import { CestaService } from '../../../cesta/cesta.service'
import { AdicionarCestaObserver } from '../../../cesta/adicionar/adicionarCesta.observer'
import { ToggleClass } from '../../../../core/toggleClass';

export class PbmFuncionalComponent {

  constructor(data) {
    this.data = data;
    this.funcionalService = new PbmFuncionalService();
    this.cestaService = new CestaService();
    this.alert = new Message();
    this.ativaDesconto = document.querySelectorAll('.ativa-desconto')
    this.compraComDesconto = document.querySelectorAll('.compra-com-desconto');
    this.buttonAtivar = document.querySelector('#pbm-form-ativar')
    this.cancelarDesconto = document.getElementById("cancelar-desconto").addEventListener("click", this.buildCancelarDesconto); 
    
    this.modalDermaclub = document.querySelector('#modal-dermaclub')
    this.modal = new ToggleClass({
      selector: this.modalSelector,
      target: this.modalDermaclub,
      class: 'modal--active',
      callback: undefined,
      blockBodyScroll: false
    })

    this.init();
  }

  init() {
    if (this.data.consultaPreco) {
      this.consultaPreco()
    } else {
      this.preAutorizacao()
    }

  }

  consultaPreco() {
    return this.funcionalService
                .postConsultaPreco(this.data)
                .subscribe(this.consultaPrecoResponse(this.data))
  }

  

  preAutorizacao() {
    return this.funcionalService
                .preAutorizacao(this.data)
                .subscribe(this.preAutorizacaoResponse())
  }

  consultaPrecoResponse(response) {
    return {
      next: response => {
        if(response.status){
          switch(response.status) {
            case 200: {
              this.consultaPrecoResponseSuccess(response.data)
              break;
            }
            case 206:
              if(response.data.codigoPrograma == "113" && response.data.statusPreAutorizacao == false) {
                this.buildModalDesvioDermaclub()
              } else {
                this.buildCadastroForm(response.data.itensDesvioFluxo[0].politicaAdesao);
              }
              break;
            default:{
              break;
            }
          }
        }else{
          this.alert.message = "Erro ao validar desconto PBM, tente novamente! - consultaPrecoResponse";
          this.alert.show();
        }
      },
      error: error => {
        let msg = "Verifique seus dados e tente novamente  - consultaPrecoResponse";
        if(error) {
          if(error.status) {
            if((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)){
              msg = error.data.map((elem) => elem.message).join(", ")
            }else if((error.status == 400 || error.status == 404) && error.data && error.data.mensagem){
              msg = error.data.mensagem;
            }

            if(!error.data) msg = "Não foi possível autorizar este item"
          }
        }

        this.alert.message = msg;
        this.alert.show();
      },
      complete: () => console.log('Complete  - consultaPrecoResponse')
    }
  }

  preAutorizacaoResponse() {
    return {
      next: response => {
        if(response.status){
          switch(response.status) {
            case 200: {
              this.preAutorizarResponseSuccess(response.data)
              break;
            }
            case 206:
              if(response.data.codigoPrograma == "113" && response.data.statusPreAutorizacao == false) {
                this.buildModalDesvioDermaclub()
              } else {
                this.buildCadastroForm(response.data.itensDesvioFluxo[0].politicaAdesao);
              }
              break;
            default:{
              break;
            }
          }
        }else{
          this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
          this.alert.show();
        }
      },
      error: error => {
        let msg = "Verifique seus dados e tente novamente";
        if(error) {
          if(error.status) {
            if((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)){
              msg = error.data.map((elem) => elem.message).join(", ")
            }else if((error.status == 400 || error.status == 404) && error.data && error.data.mensagem){
              msg = error.data.mensagem;
            }

            if(!error.data) msg = "Não foi possível autorizar este item"
          }
        }

        this.alert.message = msg;
        this.alert.show();
      },
      complete: () => console.log('Complete')
    }
  }

  buildModalDesvioDermaclub() {
    this.modal.toggle()
    return false;
  }

  buildCadastroForm(camposAdesao) {
    let subjectModalSuccess = new Subject();
    subjectModalSuccess.subscribe(new ModalPbmObserver())
    subjectModalSuccess.next(this.buildModalCadastroUnicoForm(camposAdesao))
  }

  buildModalCadastroUnicoForm (camposAdesao) {
    return {
      step: "funcional",
      atributos: camposAdesao,
      dadosPbm: this.data,
      pbm: {cadastroFormData: ''}
    }
  }

  preAutorizarResponseSuccess(preAutorizacao){  
    this.cestaService.getCarrinho().subscribe(new AdicionarCestaObserver());
  }

  consultaPrecoResponseSuccess(preAutorizacao){

    let showInCpf = document.querySelectorAll('.show-in-cpf')	
    let isNotPbm = document.querySelectorAll('.is-not-pbm')	

    if (preAutorizacao.itens.length > 0 && preAutorizacao.itens != null) {
      this.buildAutorizar()

      const numberFormat = Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'});

      document.getElementById('pbm-quantidade').textContent = "(QTDE " + preAutorizacao.itens[0].quantidadePreAutorizada + ")"
      document.getElementById('pbm-quantidade-alert').textContent = preAutorizacao.itens[0].quantidadePreAutorizada
      document.getElementById('pbm-valor').textContent = numberFormat.format(preAutorizacao.itens[0].precoLiquidoPreAutorizado)
      
      if(preAutorizacao.itens[0].quantidadeSolicitada > preAutorizacao.itens[0].quantidadePreAutorizada){
        document.getElementById('item-price-pbm-card').style.height = "370px"
        document.getElementById('item-price-pbm-card').style.paddingTop = "100px";
        
        document.getElementById('aviso-pbm').hidden = false
      }else{
        document.getElementById('item-price-pbm-card').style.height = "333px"
      }
 
      if(showInCpf != null){
        Array.prototype.forEach.call(isNotPbm, q => {	
          q.hidden = !q.hidden	
        })	
      }

      if(isNotPbm != null){
        Array.prototype.forEach.call(showInCpf, c => {	
          c.hidden = !c.hidden	
        })
      }
    }

  }

  buildAutorizar(origem){
    const itens = document.getElementsByClassName('pbm-item-melhor-preco')
    return Array.prototype.forEach.call(itens, q => {
        q.hidden = !q.hidden
    })
  }

  buildCancelarDesconto(){
    window.location.reload();
  }


  buildItemFromPreAutorizacao(preAutorizacao) {
    return preAutorizacao
            .itens
            .filter(item => item.codigoItem == this.data.item)[0]
  }

  buildMensagemQuantidade(item) {
    return `Você solicitou ${this.data.quantidadeSolicitada} unidades e foi autorizado ${item.quantidadePreAutorizada} unidades.`
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/pbm-funcional.component.js